import React, {useState,useEffect} from 'react';
import Layout from '../components/Layout/Layout.js';
import axios from 'axios';
import { useParams, useNavigate, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useCart } from '../context/cart.js';
import "../styles/ProductDetailsStyles.css";

const ProductDetails = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState({});
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [cart, setCart] = useCart();

  useEffect(() => {
    if (params?.slug) getProduct();
    // eslint-disable-next-line
  }, [params?.slug]);

  const getProduct = async () => {
    try {
      const { data } = await axios.get(
        `/api/v1/products/get-product/${params.slug}`
      );
      setProduct(data?.product);
      getSimilarProduct(data?.product._id, data?.product.category._id);
    } catch (error) {
      console.log(error);
    }
  };

  const getSimilarProduct = async (pid, cid) => {
    try {
      const { data } = await axios.get(
        `/api/v1/products/related-product/${pid}/${cid}`
      );
      setRelatedProducts(data?.products);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Layout title={`${product.name || 'تفاصيل المنتج'} - النخبة ستور`}>
      {/* Breadcrumb */}
      <div className="product-breadcrumb">
        <div className="container">
          <Link to="/">الرئيسية</Link>
          <span className="breadcrumb-sep">‹</span>
          {product?.category?.name && (
            <>
              <Link to={`/category/${product.category.slug || ''}`}>{product.category.name}</Link>
              <span className="breadcrumb-sep">‹</span>
            </>
          )}
          <span className="breadcrumb-current">{product.name}</span>
        </div>
      </div>

      {/* Product Details */}
      <div className="container product-details-container">
        <div className="row">
          {/* Image Section */}
          <div className="col-md-5">
            <div className="product-image-wrapper glass-card">
              <div className="product-image-zoom">
                <img
                  src={`/api/v1/products/product-photo/${product._id}`}
                  alt={product.name}
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* Info Section */}
          <div className="col-md-7">
            <div className="product-info-panel">
              <h1 className="product-detail-name">{product.name}</h1>
              
              {/* Price Badge */}
              <div className="product-price-badge">
                <span className="price-value">{product?.price?.toLocaleString("ar-IQ")}</span>
                <span className="price-currency">د.ع</span>
              </div>

              <div className="product-info-divider"></div>

              {/* Info Rows */}
              <div className="product-info-rows">
                <div className="info-row">
                  <span className="info-icon">📝</span>
                  <div className="info-content">
                    <span className="info-label">الوصف</span>
                    <p className="info-value">{product.description}</p>
                  </div>
                </div>
                <div className="info-row">
                  <span className="info-icon">🏷️</span>
                  <div className="info-content">
                    <span className="info-label">العلامة التجارية</span>
                    <span className="info-value">{product?.category?.name}</span>
                  </div>
                </div>
                <div className="info-row">
                  <span className="info-icon">📦</span>
                  <div className="info-content">
                    <span className="info-label">المخزن</span>
                    <span className={`stock-badge ${product.quantity > 0 ? 'in-stock' : 'out-of-stock'}`}>
                      {product.quantity > 0 ? `متوفر (${product.quantity})` : 'غير متوفر'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="product-info-divider"></div>

              {/* Add to Cart */}
              <button
                className="btn btn-gold-shimmer product-add-cart"
                onClick={() => {
                  setCart([...cart, product]);
                  localStorage.setItem("cart", JSON.stringify([...cart, product]));
                  toast.success("تمت الإضافة إلى السلة");
                }}
              >
                🛒 أضف إلى السلة
              </button>

              {/* Share */}
              <div className="product-share">
                <span className="share-label">مشاركة:</span>
                <a href={`https://wa.me/?text=${encodeURIComponent(product.name + ' - ' + window.location.href)}`} target="_blank" rel="noopener noreferrer" className="share-btn whatsapp-share">واتساب</a>
                <button className="share-btn" onClick={() => {navigator.clipboard.writeText(window.location.href); toast.success("تم نسخ الرابط");}}>نسخ الرابط</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Similar Products */}
      <div className="similar-products-section">
        <div className="container">
          <h2 className="section-heading">
            <span className="heading-line"></span>
            منتجات مشابهة
            <span className="heading-line"></span>
          </h2>
          {relatedProducts.length < 1 ? (
            <p className="text-center" style={{color: 'var(--white-muted)'}}>لا توجد منتجات مشابهة</p>
          ) : (
            <div className="similar-products-scroll">
              {relatedProducts?.map((p, index) => (
                <div className="card product-card" key={p._id} style={{animationDelay: `${index * 0.08}s`}}>
                  <div className="card-img-wrapper">
                    <img
                      src={`/api/v1/products/product-photo/${p._id}`}
                      className="card-img-top"
                      alt={p.name}
                      loading="lazy"
                    />
                  </div>
                  <div className="card-body">
                    <h5 className="card-title">{p.name}</h5>
                    <h5 className="card-title card-price">
                      {p.price.toLocaleString("ar-IQ")} د.ع
                    </h5>
                  </div>
                  <p className="card-text">
                    {p.description.substring(0, 60)}...
                  </p>
                  <div className="card-name-price">
                    <button
                      className="btn btn-info ms-1"
                      onClick={() => navigate(`/products/${p.slug}`)}
                    >
                      التفاصيل
                    </button>
                    <button
                      className="btn btn-dark ms-1"
                      onClick={() => {
                        setCart([...cart, p]);
                        localStorage.setItem("cart", JSON.stringify([...cart, p]));
                        toast.success("تمت الإضافة إلى السلة");
                      }}
                    >
                      أضف إلى السلة
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default ProductDetails;
